import React from "react";
import { PanelAddMarketer } from "../../../UI/Marketers/Add/PanelAddMarketer";

const AddMarketer = () => {
  return (
    <div>
      <PanelAddMarketer />
    </div>
  );
};

export default AddMarketer;
